import React from 'react'
import { Header1, Header3 } from '../../styles/Components'

const Header = () => {
  return (
    <div className="header" id="main-content" tabIndex="0">
      <Header1 margin="1rem 0">In the News</Header1>
      <Header3>Top and Trending Press</Header3>
    </div>
  )
}

export default Header
